export default __webpack_public_path__ + "f22c812ea577244dae7670787a000410.svg";